/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @file Component to assemble other components to construct a view.
 * @author Tom Verschoore de la Houssaije

 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media (max-width:767.98px){.container-fluid[_ngcontent-%COMP%]   .sym-insights-present[_ngcontent-%COMP%]     .sym-grid.sym-variant-agenda .sym-grid-drag .sym-grid-drag-menu .sym-rows .sym-row .sym-grid-drag-source.sym-grid-drag-source-appointments{top:-116px}.container-fluid[_ngcontent-%COMP%]   .sym-insights-present[_ngcontent-%COMP%]     .sym-grid.sym-variant-agenda .sym-grid-drag .sym-grid-drag-menu .sym-rows .sym-row .sym-grid-drag-source.sym-grid-drag-source-absences{top:-221px}}"];
export { styles as styles };
